import forEach from '@Utils/forEach'

export default class FavoritesProductEditLink {
  constructor () {
    forEach(document.querySelectorAll('[data-role="product-edit-link"]'), (i, el) => {
      el.addEventListener('click', (e) => {
        e.preventDefault()
        App.dispatcher.fire('favorites-product-edit.open')
      })
    })
  }
}
